import { StoreLayout } from "../../components/StoreLayout";
import { useCart } from "../../context/CartContext";
import { useAuth } from "../../context/AuthContext";
import { fmtINR } from "../../lib/api";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { Trash, ShoppingCart, ArrowRight } from "@phosphor-icons/react";

export default function Cart() {
  const { items, remove, total } = useCart();
  const { user } = useAuth();
  const navigate = useNavigate();

  const proceed = () => {
    if (user && user.role === "customer") navigate("/checkout");
    else navigate("/login?next=/checkout&type=customer");
  };

  return (
    <StoreLayout>
      <div className="max-w-3xl mx-auto px-5 py-12">
        <h1 className="font-heading text-3xl font-bold tracking-tight mb-6">Your Cart</h1>
        {items.length === 0 ? (
          <div className="bg-card border border-border rounded-sm p-12 text-center" data-testid="empty-cart">
            <ShoppingCart size={40} className="mx-auto text-muted-foreground" />
            <p className="text-muted-foreground mt-3">Your cart is empty.</p>
            <Button className="rounded-sm mt-5" onClick={() => navigate("/services")}>Browse Services</Button>
          </div>
        ) : (
          <>
            <div className="bg-card border border-border rounded-sm divide-y divide-border" data-testid="cart-items">
              {items.map((s, i) => (
                <div key={i} className="flex items-center justify-between p-4">
                  <div>
                    <p className="font-semibold">{s.service_type}{s.part_name ? ` · ${s.part_name}` : ""}</p>
                    <p className="text-xs text-muted-foreground">{s.product_category} · {s.product_type}</p>
                  </div>
                  <div className="flex items-center gap-4">
                    <span className="font-mono font-semibold">{fmtINR(s.amount)}</span>
                    <button onClick={() => remove(s)} className="text-destructive p-1 hover:bg-destructive/10 rounded-sm" data-testid={`cart-remove-${i}`}>
                      <Trash size={18} />
                    </button>
                  </div>
                </div>
              ))}
            </div>
            <div className="flex items-center justify-between mt-6 bg-secondary rounded-sm p-4">
              <span className="label-caps">Estimated Total</span>
              <span className="font-heading font-bold text-2xl" data-testid="cart-total">{fmtINR(total)}</span>
            </div>
            <Button className="rounded-sm w-full mt-4 h-12 gap-2" onClick={proceed} data-testid="proceed-checkout">
              Proceed to Checkout <ArrowRight size={18} weight="bold" />
            </Button>
            <p className="text-xs text-muted-foreground text-center mt-2">Pay after the service is completed.</p>
          </>
        )}
      </div>
    </StoreLayout>
  );
}
